import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faBan as fasBan } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import compact from "lodash/compact";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export interface StepFields {}

interface Props extends AbstractStepProps {
	errorList: string[];
}

export class ResultError extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const { errorList } = this.props;

		return (
			<>
				<Card.Header>
					<Card.Title className="text-center">
						Sajnos nem találtunk a megadott feltételeknek megfelelő hitelt.
					</Card.Title>
				</Card.Header>
				<Card.Body className="d-flex flex-column justify-content-center">
					<div className="text-center w-100">
						<FontAwesomeIcon icon={fasBan} size="4x" />
					</div>
					<div className="h4 mt-4 text-center w-100">
						{errorList?.map((error, index) => (
							<div key={index}>{error}</div>
						))}
					</div>
				</Card.Body>
			</>
		);
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-danger"]).join(" ");
	}

	protected getComponentName(): string {
		return "ResultError";
	}
}
